import { render, staticRenderFns } from "./CompanyCardList.vue?vue&type=template&id=6b06a84c"
import script from "./CompanyCardList.vue?vue&type=script&lang=js"
export * from "./CompanyCardList.vue?vue&type=script&lang=js"
import style0 from "./CompanyCardList.vue?vue&type=style&index=0&id=6b06a84c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports